/**
 * @generated SignedSource<<5ac3de8c93b5203ead3548ded90c8981>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleMoreStoriesArticle$data = {
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"articleMoreStoriesItemArticle">;
  } | null> | null;
  readonly " $fragmentType": "articleMoreStoriesArticle";
};
export type articleMoreStoriesArticle$key = {
  readonly " $data"?: articleMoreStoriesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreStoriesArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleMoreStoriesArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleMoreStoriesItemArticle"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "b3cb407e6260291b1f6beca4d454ef95";

export default node;
